
export const decorateEnv = (env) => {
    env.build.buildDate = '20260302052118';
    env.build.buildDateEpoch = 1772428878501;
    env.build.buildRevision = 'dd1df7728f482d10fc8e7e8eb82b14dfb9922248';
    env.build.project = 'abbottcrdx';
    env.build.part = 'rep';
    env.build.deployment = 'prd';
    env.build.viewport = 'wow';
    env.apiRoot = 'https://crdx-sfe-api.abbott.com.cn';
    env.production = 'true';
    env.variables.corpId = 'wx7dbaf21fd68d3c7a';
    env.variables.mapApiKey = 'ee95e52bf08006f63fd29bcfbcf21df0';
};
